import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../../environments/environment';

export interface SeusStatus {
  available: boolean;
  errorType?: 'timeout' | 'network' | 'server' | 'service_unavailable';
  errorStatus?: number;
  lastCheck?: Date;
}

@Injectable()
export class SeusStatusService {
  
  private seusStatusSubject = new BehaviorSubject<SeusStatus>({ available: true });
  public seusStatus$ = this.seusStatusSubject.asObservable();
  
  private urlEndPointSesion: string = environment.sesionEndPoint;
  private readonly TIMEOUT_DURATION = 60000; // 60 segundos
  
  constructor(private http: HttpClient) { }
  
  /**
   * Verifica la disponibilidad de los servicios SEUS
   * Realiza una llamada de health check al endpoint de sesión
   */
  checkSeusAvailability(): Observable<SeusStatus> {
    return this.http.get(this.urlEndPointSesion + '/datos', { observe: 'response' })
      .timeout(this.TIMEOUT_DURATION)
      .map(response => {
        const status: SeusStatus = {
          available: true,
          lastCheck: new Date()
        };
        this.seusStatusSubject.next(status);
        return status;
      })
      .catch(error => {
        const status = this.handleSeusError(error);
        this.seusStatusSubject.next(status);
        return of(status);
      });
  }
  
  /**
   * Marca los servicios SEUS como no disponibles
   */
  markSeusUnavailable(errorType: 'timeout' | 'network' | 'server' | 'service_unavailable', errorStatus: number): void {
    const status: SeusStatus = {
      available: false,
      errorType: errorType,
      errorStatus: errorStatus,
      lastCheck: new Date()
    };
    this.seusStatusSubject.next(status);
  }
  
  /**
   * Marca los servicios SEUS como disponibles
   */
  markSeusAvailable(): void {
    const status: SeusStatus = {
      available: true,
      lastCheck: new Date()
    };
    this.seusStatusSubject.next(status);
  }
  
  /**
   * Obtiene el estado actual de SEUS
   */
  getCurrentStatus(): SeusStatus {
    return this.seusStatusSubject.getValue();
  }
  
  /**
   * Verifica si SEUS está disponible
   */
  isSeusAvailable(): boolean {
    return this.seusStatusSubject.getValue().available;
  }
  
  private handleSeusError(error: any): SeusStatus {
    let errorType: 'timeout' | 'network' | 'server' | 'service_unavailable' = 'network';
    let errorStatus = 0;
    
    if (error.name === 'TimeoutError') {
      errorType = 'timeout';
      errorStatus = 0;
    } else if (error.status === 503) {
      errorType = 'service_unavailable';
      errorStatus = 503;
    } else if (error.status === 0) {
      errorType = 'network';
      errorStatus = 0;
    } else if (error.status >= 500) {
      errorType = 'server';
      errorStatus = error.status;
    }
    
    return {
      available: false,
      errorType: errorType,
      errorStatus: errorStatus,
      lastCheck: new Date()
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/seus-status.service.ts